const ArrowRightIcon = ({ width = 12, height = 12, fill = "#fff", className = "", ...props }) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={width}
      height={height}
      viewBox="0 0 15 13"
      fill="none"
      className={className}
      {...props}
    >
      <path
        d="M13.5325 4.5899L8.9435 0L8.06497 0.878539L12.6549 5.46844C12.6646 5.47821 12.6726 5.48887 12.6824 5.49864L0 5.49864L0 6.74138L12.6806 6.74138C12.6717 6.75116 12.6629 6.76182 12.6531 6.77159L8.06319 11.3615L8.94173 12.24L13.5307 7.65013C13.9394 7.2415 14.165 6.69786 14.165 6.12046C14.165 5.54305 13.9402 4.99941 13.5316 4.5899H13.5325Z"
        fill={fill}
      />
    </svg>
  );
};

export default ArrowRightIcon;
